<!-- eslint-disable max-lines -->
<template>
    <div class="registraction-manage">
        <Paper class="registraction-manage-paper">
            <el-tabs
                class="contract-list-tab-pane"
                v-model="activeTabs"
                @tab-remove="removeTab"
                @tab-click="switchTabs">
                <!-- 合同列表页 -->
                <el-tab-pane
                    label="续签登记列表"
                    name="theList"
                    ref="myPane"
                    v-loading="holePageLoading">
            <list-layout-paper>
                <template slot="header-search" class="searchBox">
                    <search-box
                        ref="searchBox"
                        :search-key="config.name"
                        :fields="config.searchFields"
                        :showResetBtn="true"
                        @search-change="accountList.searchList"
                        @elementChange="handleFielChange"
                    />
                </template>
                <template slot="header-button" class="registraction-btn">
                    <lotsButton
                        v-has="authorityCode.add"
                        type="primary"
                        icon="el-icon-circle-plus-outline"
                        size="mini"
                        @click="handleAddRow"
                        >新增</lotsButton>
                    <lotsButton
                        v-has="authorityCode.import"
                        icon="el-icon-upload2"
                        type="primary"
                        size="mini"
                        title="导入"
                        @click="openImport">导入
                    </lotsButton>
                    <report-export
                        #default="{ submit }"
                        reportCode="REPORT_CRM_CONTRACT_RENEWAL">
                            <lotsButton
                                v-has="authorityCode.newExport"
                                icon="el-icon-download"
                                type="primary"
                                size="mini"
                                @click="handleNewExport(submit, 'split')">运维导出
                            </lotsButton>
                    </report-export>
                    <lotsButton
                        v-has="authorityCode.export"
                        type="primary"
                        size="mini"
                        title="导出">
                        <el-dropdown class="registraction-manage-list-dropdown" trigger="click" :append-to-body="false">
                        <span class="el-dropdown-link">
                            导出<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="registraction-manage-list-dropdown-menu">
                            <el-dropdown-item class="dropdown-item" @click.native="handleExport">按配置字段导出</el-dropdown-item>
                            <el-dropdown-item class="dropdown-item" @click.native="handleExportByTemplate">按导入模版导出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    </lotsButton>

                    <el-tooltip effect="dark" :content="'列配置'" placement="bottom">
                        <el-button
                            icon="iconfont icon-list_install"
                            type="primary"
                            size="mini"
                            :title="'列配置'"
                            @click="showColumnConfigDialog"
                            plain />
                    </el-tooltip>
                    <span class="next-row-btn">
                        <lotsButton
                            v-has="authorityCode.exitReport"
                            icon="el-icon-guide"
                            type="primary"
                            size="mini"
                            title="退出报告流程提交"
                            :loading="exitLoading"
                            @click="handleExitReprot">退出报告流程提交
                        </lotsButton>
                        <lotsButton
                            v-has="authorityCode.dataDelFlow"
                            icon="el-icon-delete"
                            type="primary"
                            size="mini"
                            title="数据删除流程提交"
                            :loading="delFlowLoading"
                            @click="delFlowRows">数据删除流程提交
                        </lotsButton>
                    </span>

                </template>
                <!-- 表格 -->
                <template v-slot:list="{ tableHeight }">
                    <table-box
                        ref="resistractionRef"
                        :height="tableHeight"
                        v-loading="accountList.tableLoading"
                        :selection="config.selection"
                        :index="config.index"
                        :columns="config.columns"
                        :rows="accountList.totalData"
                        :actions="config.actions"
                        @action-click="actionClick"
                        @selection-change="accountList.handleSelectedRow"
                        @sort-change="handleSort"
                        @row-dblclick="(row)=>rowDBclick(row)">
                        <template #col-header="{ col }">
                            <span v-if="col.prop === 'renewalRisk'">
                                {{ col.label }}
                                <el-tooltip effect="dark" placement="top">
                                    <i class="el-icon-question"></i>
                                    <template slot="content">
                                        中高风险需要同步营销中心，拉群同步项目推动计划，协调各方解决此风险项目处理<br/>
                                    </template>
                                </el-tooltip>
                            </span>
                            <span v-else-if="col.prop === 'riskCause'">
                                {{ col.label }}
                                <el-tooltip effect="dark" placement="top">
                                    <i class="el-icon-question"></i>
                                    <template slot="content">
                                        风险原因超过2项时，建议标识为高风险<br/>
                                    </template>
                                </el-tooltip>
                            </span>
                            <span v-else-if="col.prop === 'renewalContractor'">
                                {{ col.label }}
                                <el-tooltip effect="dark" placement="top">
                                    <i class="el-icon-question"></i>
                                    <template slot="content">
                                        续签承接人每月5号/20号会收到待办<br/>
                                    </template>
                                </el-tooltip>
                            </span>
                            <span v-else>{{ col.label }}</span>
                        </template>
                        <template #col-append="{col, row, rIndex}">
                            <span v-if="col.prop === 'calCustomerLevel'">{{ codesToNames(row[col.prop], dictData[col.optionsKey]) }}</span>
                            <span v-else-if="col.prop === 'businessType'">{{ codesToNames(row[col.prop], dictData[col.optionsKey]) }}</span>
                            <span v-else-if="col.prop === 'warehouseType'">{{ codesToNames(row[col.prop], dictData[col.optionsKey]) }}</span>
                            <span v-else-if="col.prop === 'renewalRisk'" :class="[['1'].includes(row[col.prop] + '') ? 'red-color' : '']">
                                {{ codesToNames(row[col.prop], dictData[col.optionsKey]) }}
                            </span>
                            <span v-else-if="col.prop === 'riskCause'">{{ codesToNames(row[col.prop], dictData[col.optionsKey]) }}</span>
                            <span v-else-if="col.prop === 'renewalGroupCode'">
                                <a :href="row.mipUrl" class="resg-mip-link" target="_blank" :rel="col.label"  @click.prevent="toFlowHandle(row)">{{row[col.prop]}}</a>
                            </span>
                            <span v-else-if="col.prop === 'renewalDeFlowGroupCode'">
                                <a :href="row.renewalDeFlowGroupCode" class="resg-mip-link" target="_blank" :rel="col.label"  @click.prevent="toFlowHandle(row)">{{row[col.prop]}}</a>
                            </span>
                            <lots-button v-else-if="col.prop === 'file'" type="text"  @click.stop="handleOpen(row)">查看附件</lots-button>
                        </template>
                    </table-box>
                </template>
                <template slot="footer">
                    <lots-pagination
                        @size-change="accountList.sizeChange"
                        :current-page.sync="accountList.pageNo"
                        @current-change="accountList.pageChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="accountList.pageTotal" >
                    </lots-pagination>
                </template>
            </list-layout-paper>
                </el-tab-pane>
                <!-- 详情页签 -->
                <el-tab-pane
                    closable
                    :class="item.code + item.detailPageState"
                    v-for="item in tabList"
                    :key="item.code + item.detailPageState"
                    :label="item.contractMark"
                    :name="item.code + item.detailPageState">
                    <detail-page
                        :ref="`datailTabs${item.code + item.detailPageState}`"
                        :code="item.code"
                        :key="item.detailPageState"
                        @apply-change="applyChange"
                        :activeTabs="activeTabs"
                        :detailPageState="item.detailPageState"
                        :disableBus="item.buttonData"
                        :detailData="item.detailData">
                    </detail-page>
                </el-tab-pane>
            </el-tabs>
            <add-file-dialog
                v-if="addFileVisible"
                :fileReadonly="fileReadonly"
                :row="theRow"
                @confirm="dialogConfirm"
                @handleClose="addFileVisible = false">
            </add-file-dialog>
            <!-- 表格列配置弹框 -->
            <column-config
                :pageID="config.name"
                :initColumns="config.columns"
                ref="otpColumnConfig"
                @header-change="config.columns = $event"
            />
            <!-- 导入弹窗 -->
            <el-dialog
                @close="closeLog"
                destroy-on-close
                v-loading="importLoading"
                title="导入数据"
                :visible.sync="addDialog"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                width="600px">
                <el-form
                    :model="filesForm"
                    label-position="right"
                    class="form-dialog"
                    label-width="80px"
                    ref="filesFormDialog">
                    <div class="upload-btn">
                        <lots-button size="mini" type="primary" @click="downLoad"
                            :loading="downloadLoading">下载模板</lots-button>
                        <lots-upload-button :text="'添加附件'"  :bucket="'annto-lcrm'"
                        @beforeUpload="beforeUploadUrl" @callback="(data) => { upLoadFileUrl( data); }"></lots-upload-button>
                    </div>
                    <el-form-item label="附件名称：" prop="fileName">
                        <span>{{ filesForm.fileName || '--' }}</span>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                <lots-button size="mini" @click="closeLog">取 消</lots-button>
                <lots-button size="mini" type="primary" @click="incrementImport" :disabled="!filesForm.fileUrl" :loading="importLoading">导入</lots-button>
                </span>
            </el-dialog>
            <!-- 添加续签合同 -->
        <advance-multi-dialog
            ref="advanceMultiDialog"
            @confirm="contractSaveSure">
        </advance-multi-dialog>
        </Paper>
    </div>
</template>
<script>
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
// import editTableBox from '@/components/lots/editTableBox/Index';
import tableBox from '@/components/lots/tableBox/Index';
import {
    contractRenewalRegistrationPage,
    registrationImportApi,
    renewalFileDownloadApi,
    contractRenewalRegistrationDel,
    contractRenewalRegistrationInsert,
    registrationVerify,
    getRenewalRole,
    renewalExport,
    renewalByImportTemplateExport,
    getIndustryTree,
    registrationGetByIdApi,
    registrationDelVerify
} from '@mdm/api/contractManage/contractRegistration.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { config as configStatic, checkDelFlowStatus, checkExitReportFlowStatus } from './config';
import { ref, reactive, onMounted, onActivated, computed, getCurrentInstance } from '@vue/composition-api';
import { Message } from 'element-ui';
import utils from '@/components/utils/common.js';
import store from '@/store';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import _ from 'lodash';
import Decimal from 'decimal.js';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import lotsButton from '@/components/lots/lotsButton';
import reportExport from '@/components/lots/reportExportPlugin';
import columnConfig from '@/components/lots/columnConfig/Index';
import addFileDialog from '@/modules/mdm/views/contractModules/components/addFileDialog/Index';
import detailPage from './detail/Detail.vue';
import advanceMultiDialog from '@/components/lots/otpAdvanceMultiDialog';
import lotsUploadButton from '@/components/lots/oss/UploadBtn';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
const { MAGIC_NUMBER } = utils;
const EDIT_TYPE = {
    EDIT: 2,
    CANCEL: -3
};
export default {
    name: 'contractRegistration',
    components: {
        Paper,
        listLayoutPaper,
        searchBox,
        tableBox,
        // editTableBox,
        lotsPagination,
        lotsButton,
        reportExport,
        addFileDialog,
        columnConfig,
        detailPage,
        advanceMultiDialog,
        lotsUploadButton
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(configStatic);
        const searchObj = reactive({});
        const authorityCode = reactive(btnAuthority.contractRegistration);
        const { user } = store.getters;
        class AccountListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map(v => {
                        v.edit = -3;
                        v.allowEdit = true;
                        v.contractStatus = (v.contractStatus || v.contractStatus === 0) ? v.contractStatus + '' : '';
                        v.contractCharacter = (v.contractCharacter || v.contractCharacter === 0) ? v.contractCharacter + '' : '';
                        if (!_.isNil(v.contractScale) && v.contractScale !== '') {
                            v.contractScale = Decimal(v.contractScale).toFixed(2);
                        }
                        return v;
                    });
                    this.pageTotal.value = res.data.totalCount;
                    setupContext.root.$nextTick(() => {
                        setupContext.refs.resistractionRef.$refs.elTable.doLayout(); // 解决表格错位
                    });
                }
            };
        }
        const accountList = new AccountListClass({
            Api: {
                listApi: contractRenewalRegistrationPage, // 查询接口
                deleteApi: contractRenewalRegistrationDel
            }
        });
        const handleFielChange = _.debounce(({ column, searchData }) => {
            if (searchData.contractCodes) {
                const orderNoS = searchData.contractCodes.split(/,|，|;|；|\r|\n|\r\n|\s+/);
                searchData.contractCodes = orderNoS.join(';');
            }
        }, MAGIC_NUMBER.TWO_HUNDRED);
        // eslint-disable-next-line complexity
        const searchDataFormat = (condition = {}, params = {}) => {
            if (condition.effectTime && condition.effectTime.length) {
                condition.effectStartTime = utils.formatDateTime(condition.effectTime[0]);
                condition.effectEndTime = utils.formatDateTime(condition.effectTime[1]);
                Reflect.deleteProperty(condition, 'effectTime');
            }
            if (condition.validTime && condition.validTime.length) {
                condition.startValidTime = utils.formatDateTime(condition.validTime[0]);
                condition.endValidTime = utils.formatDateTime(condition.validTime[1]);
                Reflect.deleteProperty(condition, 'validTime');
            }
            if (condition.failTime && condition.failTime.length) {
                condition.startFailTime = utils.formatDateTime(condition.failTime[0]);
                condition.endFailTime = utils.formatDateTime(condition.failTime[1]);
                Reflect.deleteProperty(condition, 'failTime');
            }
            if (Array.isArray(condition.calCustomerLevelCodes)) {
                const codeSortBy = _.sortBy(condition.calCustomerLevelCodes);
                condition.calCustomerLevelCodeStr = codeSortBy.join(',');
            }
            if (condition.customerGroupCode) {
                condition.customerGroupCodeList = [condition.customerGroupCode];
                Reflect.deleteProperty(condition, 'customerGroupCode');
                Reflect.deleteProperty(condition, 'customerGroupName');
            }
            if (condition.renewalFlowStatus) {
                condition.renewalFlowStatusList = condition.renewalFlowStatus;
                Reflect.deleteProperty(condition, 'renewalFlowStatus');
            }
            if (condition.renewalDeFlowStatus) {
                condition.renewalDeFlowStatusList = condition.renewalDeFlowStatus;
                Reflect.deleteProperty(condition, 'renewalDeFlowStatus');
            }
            if (condition.earlyTerminationTime) {
                condition.startEarlyTerminationTime = utils.formatDateTime(condition.earlyTerminationTime[0]);
                condition.endEarlyTerminationTime = utils.formatDateTime(condition.earlyTerminationTime[1]);
                Reflect.deleteProperty(condition, 'earlyTerminationTime');
            }
            if (condition.followupExpiryDate) {
                condition.followupExpiryStartDate = utils.formatDateTime(condition.followupExpiryDate[0]);
                condition.followupExpiryEndDate = utils.formatDateTime(condition.followupExpiryDate[1]);
                Reflect.deleteProperty(condition, 'followupExpiryDate');
            }
            // 新增：解析行业大类（支持多个）
            if (Array.isArray(condition.industryCategoriesCode) && condition.industryCategoriesCode.length > 0) {
            //    / 使用 _.zip 将行列转置
                const transposed = _.zip(...condition.industryCategoriesCode);
                // 获取转置后的数组并拼接成字符串
                condition.industryCategoriesCodes = _.uniq(transposed[0]).join(',');
                condition.industryTypeCodes = _.uniq(transposed[1]).join(',');
                Reflect.deleteProperty(condition, 'industryCategoriesCode');
            }
            condition.orderBy = orderBy.value;
            condition.orderByType = orderByType.value;
            condition.userCode = user.userCode;
            Object.keys(condition).forEach(v => {
                !condition[v] && condition[v] !== 0 && (condition[v] = undefined);
            });
            return { ...condition, ...params };
        };
        const tabList = ref([]); // 打开的详情tab页集
        const activeTabs = ref('theList');
        const removeTab = (targetName) => { // 删除详情标签
            if (activeTabs.value === targetName) {
                activeTabs.value = 'theList';
            }
            tabList.value = tabList.value.filter(
                (tab) => (tab.code + tab.detailPageState) !== targetName
            );
        };
        const switchTabs = (data) => {
            if (data.name === 'theList') {
                accountList.getList(setupContext.refs.searchBox.searchData);
            }
        };
        const currDetailData = ref({});
        // 双击表格
        const rowDBclick = (row, status = 'main', name = '续签登记') => {
            // 滚动到顶部
            const element = document.getElementsByClassName('app-main');
            element[0].scrollTo(0, 0);
            currDetailData.value = _.cloneDeep(row); // 深拷贝是防止表格源数据被修改
            // const status = 'main';
            // const name = '续签登记';
            const { contractCode, companyCode } = row;
            const code = contractCode + companyCode; // 合同编码+分公司编码 （唯一）
            newDetailPage(code, currDetailData.value, name, status);
        };
        const newDetailPage = (code, data, name, state) => {
            data.contractStatus = data['contractStatus'] ? data['contractStatus'] : 0;
            const judge = tabList.value.filter((item) => (item.code + item.detailPageState) === code + state);
            if (judge.length === 0 && tabList.value.length === 8) {
                Message.warning('已超出8个详情页，请关闭后重新打开');
            } else {
                const dataGather = {
                    contractMark: name + code.substring(code.length - 4),
                    code,
                    detailData: _.cloneDeep(data),
                    detailPageState: state
                };
                if (judge.length === 0) {
                    // 第一次打开
                    tabList.value.push(dataGather);
                }
                // 编辑时更新当前数据
                const _index = tabList.value.findIndex((item) => (item.code + item.detailPageState) === code + state);
                if (_index > -1 && !_.isEqual(data, tabList.value[_index].detailData)) {
                    tabList.value[_index] = dataGather;
                }
                activeTabs.value = code + state; // tabs切换到对应详情页
            }
        };
        const holePageLoading = ref(false);
        const otpColumnConfig = ref(null);
        const showColumnConfigDialog = () => {
            otpColumnConfig.value.show(true);
        };
        const addFileVisible = ref(false);
        const fileReadonly = ref(false);
        const theRow = ref({});
        const handleOpen = (row) => {
            if (row.edit === EDIT_TYPE.CANCEL) {
                fileReadonly.value = true;
            } else {
                fileReadonly.value = false;
            }
            theRow.value = row;
            addFileVisible.value = true;
        };
        const dialogConfirm = (data) => {
            theRow.value.edit !== EDIT_TYPE.CANCEL && (theRow.value.file = data);
            addFileVisible.value = false;
        };
        const actionClick = (event, row, index) => {
            if (event === 'edit') {
                rowDBclick(row);
            }
        };
        const handleNewExport = async(submit, type) => {
            await setupContext.refs.searchBox.submitSearch(); // 解决输入参数不生效问题
            const { value } = accountList.searchModel;
            const newData = searchDataFormat(_.cloneDeep(value)); // 解决搜索参数被清空的问题
            await getCurrentUserRole(newData);
            const params = {
                ...newData,
                authContractCodeList: authContractCodeList.value,
                authContractCodeFlag: authContractCodeFlag.value,
                authIdList: authIdList.value,
                deleteFlag: 0
            };
            Object.keys(params).forEach(v => {
                if (params[v] === undefined || params[v] === null || params[v] === '') {
                    delete params[v];
                }
            });

            submit(params);
        };
        const rendertable = ref(true);
        const orderBy = ref('fail_time');
        const orderByType = ref('desc');
        // 排序
        const handleSort = ({ prop, order }) => {
            orderBy.value = prop.replace(/([A-Z])/g, '_$1').toLowerCase();
            orderByType.value = order === 'ascending' ? 'asc' : 'desc';
            accountList.getList();
        };
        const codesToNames = computed(() => {
            function codeToName (codes, dictObj) {
                const names = [];
                const codesArr = codes ? codes.split(',') : [];
                if (codesArr && codesArr.length) {
                    codesArr.forEach((key) => {
                        if (dictObj && dictObj[key]) {
                            names.push(dictObj[key]); // dictData.value['SYS_BMS_BUSI_TYPE']
                        }
                    });
                }
                return names.join(',');
            };
            return codeToName;
        });
        const openImport = () => {
            addDialog.value = true;
        };
        const fileList = ref([]);
        const filesForm = ref({ fileName: '' });
        const addDialog = ref(false);
        const downloadLoading = ref(false);
        // 下载模板
        const downLoad = (data) => {
            downloadLoading.value = true;
            renewalFileDownloadApi({ fileName: 'LCRM续签合同登记导入模板.xlsx' }).then(res => {
                try {
                    return JSON.parse(res); // 是 JSON 对象
                } catch (e) {
                    Message.success('下载成功');
                }
            }).finally(() => { downloadLoading.value = false; });
        };

        const beforeUploadUrl = res => {
            filesForm.value.fileName = res.file.name;
        };
        const upLoadFileUrl = (res) => {
            if (res && +res.code === 0) {
                filesForm.value = {
                    fileUrl: res.data.downUrl,
                    fileName: res.data.name || filesForm.value.fileName
                };
            }
        };
        // const bottomFileImport = () => {
        //     if (!fileUrlList.value.internalSealFileUrl) return '请上传附件';
        //     sharingRulesFileImport(fileUrlList.value).then(res => {
        //         if (res && +res.code === 0) {
        //             Message.success('上传成功');
        //             addDialog.value = false;
        //         }
        //     });
        // };
        // 增量/覆盖导入
        const incrementImport = async (val) => {
            if (!filesForm.value?.fileUrl) {
                return Message.warning('请先上传附件');
            }
            const params = {
                fileUrl: filesForm.value?.fileUrl,
                fileName: filesForm.value?.fileName
            };
            // 处理URL后面的参数拼接

            // 把接口需要的参数带进去
            importLoading.value = true;
            registrationImportApi(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('导入成功');
                    accountList.getList();
                    addDialog.value = false;
                }
            }).catch(() => { importLoading.value = false; }).finally(() => {
                importLoading.value = false;
            });
        };
        const closeLog = () => {
            fileList.value = [];
            filesForm.value.fileName = '';
            filesForm.value.fileUrl = '';
            addDialog.value = false;
        };
        // 上传失败
        const handleError = () => {
            Message.error('上传失败');
        };
        const onChange = (file) => {
            fileList.value = [];
            filesForm.value.fileName = file.name;
            fileList.value.push(file);
        };
        const importLoading = ref(false);
        // 导入
        const handleAddRow = async () => { // 新增
            setupContext.refs.advanceMultiDialog.show(true, config.contractAdvanceParams, {});
        };
        const contractSaveSure = async (data) => {
            contractRenewalRegistrationInsert(data).then(res => {
                if (res && +res.code === 0) {
                    Message.success('添加成功');
                }
            }).finally(() => {
                accountList.getList();
            });
        };
        const exitLoading = ref(false);
        const delFlowLoading = ref(false);
        const ctx = getCurrentInstance(); // 通过该方法访问当前组件的实例对象,相当于this
        const handleExitReprot = () => {
            if (!accountList.selectedRows.value.length) {
                return Message.warning('请勾选表格数据再操作！');
            }
            if (!validateItems(accountList.selectedRows.value)) {
                return Message.warning('合同编码、分公司不能为空');
            }
            const tipsText = checkStatusWithLodash(accountList.selectedRows.value);
            if (tipsText.length) {
                return Message.warning({
                    message: tipsText.join('<br />') + '<br />续签状态不等于已终止，无需提交退出流程报告；',
                    dangerouslyUseHTMLString: true
                });
            }
            exitLoading.value = true;
            registrationVerify(accountList.selectedRows.value.map(it => it.id)).then(res => {
                if (res && +res.code === 0) {
                    const uuid = utils.uuid();
                    store.commit('updateRegistrationReprotList', { id: uuid, list: accountList.selectedRows.value });
                    ctx.$router.push({ path: '/registractionFlow', query: { uuid: uuid } });
                }
            }).finally(() => {
                exitLoading.value = false;
            });
        };

        const delFlowRows = async () => { // 数据删除流程提交
            if (!accountList.selectedRows.value.length) {
                return Message.warning('请勾选表格数据再操作！');
            }
            if (!validateItems(accountList.selectedRows.value)) {
                return Message.warning('合同编码、分公司不能为空');
            }
            // 校验①：退出报告流程审批状态
            const exitReportTips = checkExitReportFlowStatus(accountList.selectedRows.value, dictData.value);
            let errorTips = [];
            if (exitReportTips.length) {
                errorTips = errorTips.concat(exitReportTips);
            }
            // 校验②：数据删除流程审批状态
            const delFlowTips = checkDelFlowStatus(accountList.selectedRows.value, dictData.value);
            if (delFlowTips.length) {
                errorTips = errorTips.concat(delFlowTips);
            }
            if (errorTips.length) {
                return Message.warning({
                    message: errorTips.join('<br />'),
                    dangerouslyUseHTMLString: true
                });
            }
            // 校验通过，跳转至数据删除流程页面
            delFlowLoading.value = true;
            registrationDelVerify(accountList.selectedRows.value.map(it => it.id)).then(res => {
                if (res && +res.code === 0) {
                    const uuid = utils.uuid();
                    store.commit('updateRegistrationReprotList', { id: uuid, list: accountList.selectedRows.value });
                    ctx.$router.push({ path: '/delApplyFlow', query: { uuid: uuid } });
                }
            }).finally(() => {
                delFlowLoading.value = false;
            });
        };
        const renewalEndStatus = '3'; // 已终止
        const checkStatusWithLodash = (dataList) => {
            return _(dataList)
                .filter(item => String(item.renewalStatus) !== renewalEndStatus)
                .map(item => {
                    return `合同编码：${item.contractCode || ''}，分公司：${item.companyName || ''};`;
                })
                .value();
        };
        const toExcelObject = {
            renewalGroupCode: 'mipUrl',
            renewalDeFlowGroupCode: 'deFlowMipUrl'
        };
        // 工具函数：转excelTitle对象
        const toExcelTitle = (item) => ({
            name: item.name,
            property: ['renewalGroupCode', 'dataDelSubmitFlowCode'].includes(item.property) ? toExcelObject[item.property] : item.property
        });
        // const detailExportLoading = ref(false);
        const handleExport = async () => {
            await setupContext.refs.searchBox.submitSearch(); // 解决输入参数不生效问题
            const { value } = accountList.searchModel;
            const newData = searchDataFormat(_.cloneDeep(value)); // 解决搜索参数被清空的问题
            const excelFileList = otherUtils.sortColumnsByFixed(config.columns)?.filter(it => it.property !== 'file');
            const excelTitleList = excelFileList?.map(toExcelTitle);
            const params = {
                ...newData,
                deleteFlag: 0,
                excelTitleList
            };
            Object.keys(params).forEach(v => {
                if (params[v] === undefined || params[v] === null || params[v] === '') {
                    delete params[v];
                }
            });
            renewalExport(params).then(res => {
                if (+res.code === 0) {
                    Message.success('已发送导出请求,请稍后到右上角用户文件列表中下载');
                }
            }).finally(() => { });
        };
        const handleExportByTemplate = async () => {
            await setupContext.refs.searchBox.submitSearch();
            const { value } = accountList.searchModel;
            const newData = searchDataFormat(_.cloneDeep(value));
            const params = {
                ...newData,
                deleteFlag: 0
                // TODO: Add or modify params here if needed for template export
            };
            Object.keys(params).forEach(v => {
                if (params[v] === undefined || params[v] === null || params[v] === '') {
                    delete params[v];
                }
            });
            renewalByImportTemplateExport(params).then(res => {
                if (+res.code === 0) {
                    Message.success('已发送导出请求,请稍后到右上角用户文件列表中下载');
                }
            }).finally(() => { });
        };
        const validateItems = (items) => {
            return _.every(items, item => {
                // 检查 id 和 name 都存在且不是 null/undefined/空字符串
                return !_.isNil(item.contractCode) && !_.isNil(item.companyCode)
           && item.contractCode !== '' && item.companyCode !== '';
            });
        };
        const toFlowHandle = (row) => {
            if (row.renewalGroupCode) {
                ctx.$router.push({ path: '/registractionFlow', query: { renewalGroupCode: row.renewalGroupCode } });
            } else if (row.renewalDeFlowGroupCode) {
                ctx.$router.push({ path: '/delApplyFlow', query: { renewalGroupCode: row.renewalDeFlowGroupCode } });
            } else {
                window.open(row.mipUrl, '_blank');
            }
        };
        const authContractCodeList = ref(null);
        const authContractCodeFlag = ref(null);
        const authIdList = ref(null);
        const getCurrentUserRole = (params) => {
            return getRenewalRole(params).then(res => {
                if (res && +res.code === 0) {
                    authContractCodeList.value = res.data.authContractCodeList;
                    authContractCodeFlag.value = res.data.authContractCodeFlag;
                    authIdList.value = res.data.authIdList;
                }
            });
        };
        const industryData = ref([]);
        const getIndustryTreeList = () => {
            return getIndustryTree({
                industryStatus: 1 // 0-停用、1-启用
            }).then(res => {
                if (res && +res.code === 0) {
                    industryData.value = res.data;
                }
            });
        };
        const applyChange = (data, status, name) => {
            rowDBclick(data, status, name);
        };
        const flowDetailData = ref({});
        const fetchData = id => {
            return registrationGetByIdApi({ id }).then(res => {
                if (+res.code === 0 && res.data) {
                    flowDetailData.value = res.data;
                }
            });
        };
        onActivated(() => {
            // setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
        });
        const dictData = ref({});
        onMounted(async() => {
            const res = await getDictDataApi({
                dictCodes: `CRM_CONTRACT_RENEWAL_STATUS,RENEWAL_AUDIT_STATUS,NEOCRM_CUSTOMER_LEVEL,SYS_BMS_BUSI_TYPE,CRM_CONTRACT_RENEWAL_RISK,NEOCRM_WH_TYPE,
                CRM_CONTRACT_RENEWAL_RISK,CRM_CONTRACT_RENEWAL_RISK_CAUSE`
            });
            dictData.value = res.data;
            await getIndustryTreeList();
            config.searchFields.forEach(it => {
                if (it.value === 'industryCategoriesCode') {
                    it.options = industryData.value;
                }
                if (it.value === 'renewalStatusList') {
                    const options = Object.entries(dictData.value.CRM_CONTRACT_RENEWAL_STATUS).map(arr => ({
                        value: arr[0],
                        label: arr[1]
                    }));
                    options.push({ value: '0', label: '空' }); // 添加空
                    it.options = options;
                }
                if (it.value === 'renewalRisk') {
                    const options = Object.entries(dictData.value.CRM_CONTRACT_RENEWAL_RISK).map(arr => ({
                        value: arr[0],
                        label: arr[1]
                    }));
                    options.push({ value: '4', label: '空' }); // 添加空
                    it.options = options;
                }
            });
            const queryParams = {
                // effectTime: utils.defaultDate('365')
            };
            setupContext.refs.searchBox.setQueryParams(queryParams);
            setupContext.refs.searchBox.submitSearch();
            if (ctx.$route.query.id) {
                await fetchData(ctx.$route.query.id);
                rowDBclick({ ...flowDetailData.value, changeCode: ctx.$route.query.changeCode }, 'change', '续签登记变更');
            }
        });
        return {
            accountList,
            config,
            otpColumnConfig,
            showColumnConfigDialog,
            holePageLoading,
            utils,
            authorityCode,
            handleExport,
            rendertable,
            handleSort,
            codesToNames,
            handleFielChange,
            dictData,
            actionClick,
            addFileVisible,
            theRow,
            dialogConfirm,
            handleOpen,
            fileReadonly,
            removeTab,
            switchTabs,
            rowDBclick,
            activeTabs,
            tabList,
            downLoad,
            fileList,
            filesForm,
            addDialog,
            openImport,
            downloadLoading,
            closeLog,
            handleError,
            onChange,
            importLoading,
            handleAddRow,
            contractSaveSure,
            searchObj,
            handleExitReprot,
            exitLoading,
            delFlowLoading,
            toFlowHandle,
            handleNewExport,
            upLoadFileUrl,
            beforeUploadUrl,
            incrementImport,
            handleExportByTemplate,
            applyChange,

            delFlowRows
        };
    }
};
</script>
<style lang="less">
.registraction-manage {
    width: 100%;
    .registraction-manage-paper {
        height: 100%;
    }
    .list-layout-wrapper {
        height: 100%;
    }
    .contract-list-tab-pane.el-tabs {
        width: 100%;
        height: 100%;
        & > .el-tabs__content {
            height: calc(100% - 40px - 14px);
            overflow: auto;
            & > .el-tab-pane {
                overflow: auto;
                padding-right: 5px;
                height: 100%;
                .list-main {
                    .table-box {
                        height: 100%;
                    }
                }
            }
        }
    }
    .flex-layout .list-main {
        overflow: auto;
    }

    .flex-layout .table {
        overflow-y: auto;
    }
    .list-header {
        .registraction-manage-list-dropdown.el-dropdown {
            color: #fff;
        }
    }

    .layout-content.registraction-manage-paper {
        padding: 0px 20px 20px;
        .el-table .cell.el-tooltip {
            &>div {
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .list-layout-wrapper {
        padding: 0px;
    }
    .red-color {
        color: red;
    }
    .upload-btn {
        display: flex;
        // padding: 0px 0px 15px 80px;
        margin: 0 0 0 8px;
        .upload-demo {
            margin-left: 10px;
        }
    }
    .list-layout .list-header .el-input {
        margin-left: 0;
    }
    .header-button::after {
        content: "";
        display: table;
        clear: both;
    }

    .header-button button {
        float: left;
        margin-bottom: 10px;
    }

    .header-button .next-row-btn {
        float: none;
        clear: both;
        display: block;
        margin-top: 10px;
        margin-left: 0px;
    }

}
.registraction-manage-list-dropdown.el-dropdown {
    color: #fff;
    vertical-align: middle;
    .el-button--mini {
        padding: 7px 15px;
    }
}
.registraction-manage-list-dropdown-menu {
    background: #fff;
    padding: 0;
    white-space: nowrap;
    .dropdown-item {
        width: 90px!important;
        color: #333;
        font-size: 14px;
        padding: 8px 20px;
        line-height: 1.5;
        cursor: pointer;
        transition: background 0.2s, color 0.2s;
        text-align: center;
        justify-content: center;
        display: flex;
        color: #4285f5;
    }
    .dropdown-item:hover {
        background: #f5f7fa;
        color: #4285f5;
    }
}
.column-config_title {
    font-size: 14px;
}

.resg-mip-link{
    text-decoration: none;
    display: inline-flex;
}
</style>
